module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/camera-5276830de90d8c12b7ca571a5b985633.svg";